"use client";

import { Box, styled } from "@mui/material";

export default styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "2px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  maxWidth: "440px",
  overflow: "hidden",
  width: "100%",
}));
